/**
 * Global JS
 */

// CSS
import '../scss/global.scss';

// Vendors
import $ from 'jquery';
import 'jquery.easing';
import 'jquery.maskedinput/src/jquery.maskedinput';
import './lib/polyfills';
import './lib/wl-share';
import './lib/lazyload-bg-images';

// Framework
import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';

// Site modules
import './site/base';
import './site/card-media-popup';
import './site/card-propane-use';
import './site/card-propane-council-resource';
import './site/cookie-consent';
import './site/email-link';
import './site/footer';
import './site/gallery-propane-products';
import './site/load-more';
import './site/localized-content-injection';
import './site/manage-profile';
import './site/marquee';
import './site/media-gallery';
import './site/mega-menu';
import './site/nav-mobile';
import './site/nav-primary';
import './site/nav-tertiary';
import './site/page-header';
import './site/print-page';
import './site/search-form';
import './site/section-header';
import './site/sticky-utilities';
import './site/testimonials';
import './site/video-modal';
import './site/video-player';
import './site/gated';
import './site/wysiwyg';
import './site/vendor-facetwp';
import './site/vendor-woocommerce';
import './site/horizontal-scroll';
import './site/accordion';
import './site/okta-login';
import './site/nav-secondary';
import './site/banner';

import globalLoader from './site/global-loader';

// Utilities
import { getCookieValue } from './lib/utilities';

// Apply input masks
$('.mask-input-phone').mask('(999) 999-9999');
$('.mask-input-date').mask('99/99/9999');
$('#date_needed_by').mask('99/99/9999');

// Init single carousel
const carouselSingle = carousels('[data-carousel="single"]', {
  autoplay: true,
  dots: true,
  infinite: true,
  speed: 500
});

// Init single carousel
const carouselCardFeature = carousels('[data-carousel="card-feature"]', {
  autoplay: false,
  dots: true,
  infinite: true,
  speed: 500,
  nextArrow:
    '<button type="button" class="slick-next module-hover-root"><span class="btn__arrow arrow arrow--blue"></span></button>',
  prevArrow:
    '<button type="button" class="slick-prev module-hover-root"><span class="btn__arrow arrow arrow--flip arrow--blue"></span></button>'
});

// Init multiple carousel
const carouselMultiple = carousels('[data-carousel="multiple"]', {
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});

// Init scrollingList carousel
const carouselScrollingList = carousels('[data-carousel="scrollingList"]', {
  autoplay: true,
  dots: true,
  dotsClass: 'slick-dots slick-dots--blue',
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 440,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

// Init notices
notices('[data-notice-dismissible]');

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');

// Prevent default
$('[data-click-prevent-default]').on('click', (event) =>
  event.preventDefault()
);

// Stop propagation
$('[data-click-stop-propagation]').on('click', (event) =>
  event.stopPropagation()
);

// Favorites button event
$(document).on(
  'favorites-updated-single',
  (event, favorites, post_id, site_id, status) => {
    if (window.location.href.indexOf('account') > -1) {
      // Remove card when unfavorited
      if (status !== 'active') {
        $(`[data-favorite-id="${post_id}"]`).remove();

        if ($(`[data-favorite-id]`).length <= 0) {
          $('.favorite-grid').hide();
          $('.no-favorite-grid').show();
        } else {
          $('.favorite-grid').show();
          $('.no-favorite-grid').hide();
        }
      }
    } else {
      // Show/hide modal when favorite/unfavorite
      if (status === 'active') {
        $('[data-modal="favorite_active_modal"]').trigger('modal:show');
      } else {
        $('[data-modal="favorite_inactive_modal"]').trigger('modal:show');
      }
    }
  }
);

// Validate shipping address from
$('#add_shipping_address').on('click', () => {
  if (
    $.trim($('#shipping_address_form input[name=first_name]').val()) === '' ||
    $.trim($('#shipping_address_form input[name=address_1]').val()) === '' ||
    $.trim($('#shipping_address_form input[name=postcode]').val()) === '' ||
    $.trim($('#shipping_address_form input[name=city]').val()) === '' ||
    $.trim($('#shipping_address_form select[name=state]').val()) === ''
  ) {
    $('#shipping_address_modal .notice').removeClass('u--display-none');
    return false;
  }
  $('#shipping_address_form').submit();
});

// Validate billing address from
$('#add_billing_address').on('click', () => {
  if (
    $.trim($('#billing_address_form input[name=first_name]').val()) === '' ||
    $.trim($('#billing_address_form input[name=address_1]').val()) === '' ||
    $.trim($('#billing_address_form input[name=postcode]').val()) === '' ||
    $.trim($('#billing_address_form input[name=city]').val()) === '' ||
    $.trim($('#billing_address_form select[name=state]').val()) === ''
  ) {
    $('#billing_address_modal .notice').removeClass('u--display-none');
    return false;
  }
  $('#billing_address_form').submit();
});

// Manage Profile
if ($('#profile_form').length) {
  const selected_role = $('select[name=selected_role]');
  const basic_roles = ['consumer', 'interested_propane'];

  if (basic_roles.includes(selected_role.val())) {
    showRequiredFields(false);
  } else {
    showRequiredFields(true);
  }

  $(selected_role).on('change', () => {
    if (basic_roles.includes(selected_role.val())) {
      return showRequiredFields(false);
    } else {
      return showRequiredFields(true);
    }
  });
}

// Open popup on edit address click fetch address detail
$('.edit_address').on('click', (event) => {
  const address_id = $(event.currentTarget).data('count-id');
  const address_type = $(event.currentTarget).data('address-type');

  $.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php?action=edit_user_addresses',
    dataType: 'json',
    data: { address_id, address_type },
    success: (data) => {
      $('#edit_address_container').html('');
      $('#edit_address_container').html(data);
      $('[data-modal="edit_address_modal"]').trigger('modal:show');
    },
    error: (jqXHR, exception) => {}
  });
});

// Validate edit address from
$('#update_address').on('click', () => {
  if (
    $.trim($('#edit_address_form input[name=first_name]').val()) === '' ||
    $.trim($('#edit_address_form input[name=address_1]').val()) === '' ||
    $.trim($('#edit_address_form input[name=postcode]').val()) === '' ||
    $.trim($('#edit_address_form input[name=city]').val()) === '' ||
    $.trim($('#edit_address_form select[name=state]').val()) === ''
  ) {
    $('#edit_address_modal .notice').removeClass('u--display-none');
    return false;
  }
  $('#edit_address_form').submit();
});

// Open popup on edit address click fetch address detail
$('.delete_address').on('click', (event) => {
  const address_id = $(event.currentTarget).data('count-id');
  const address_type = $(event.currentTarget).data('address-type');
  // $('[data-modal="confirm_modal"]').trigger('modal:show');

  $.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php?action=delete_user_addresses',
    dataType: 'json',
    data: { address_id, address_type },
    success: (data) => {
      $('#confirm_container').html('');
      $('#confirm_container').html(data);
      $('[data-modal="confirm_modal"]').trigger('modal:show');
    },
    error: (jqXHR, exception) => {}
  });
});

// Track Download
$('.download-product, [data-hs-evt]').on('click', (event) => {
  event.preventDefault();
  const $this = $(event.currentTarget);
  globalLoader.show();
  const post_id = $this.data('post_id');
  const gated = $this.data('gated');
  const hubspotEventName = $this.data('hs-evt')
    ? $this.data('hs-evt')
    : 'Downloaded Item';
  const hubspotEventIDMap = {
    customize_and_download: 'pe3572053_customized_download_item',
    customize_and_print: 'pe3572053_customized_print_item',
    send_to_printer: 'pe3572053_printed_item'
  };

  if (!gated) {
    $.ajax({
      type: 'POST',
      url: '/wp-admin/admin-ajax.php?action=add_download',
      dataType: 'json',
      data: { post_id },
      success: ({ success, data: { redirect_url, product, user } }) => {
        if (success) {
          // Figure out redirect target.
          const target =
            redirect_url && $this.attr('href') === '#'
              ? redirect_url
              : $this.attr('href');

          // Log download to hubspot..
          if (window._hsq) {
            _hsq.push(['identify', { email: user.email }]);
            _hsq.push([
              'trackCustomBehavioralEvent',
              {
                name: hubspotEventIDMap[hubspotEventName],
                properties: {
                  product_title: product.title,
                  product_sku: product.sku
                }
              }
            ]);
          }

          globalLoader.hide();
          // ..and redirect.
          window.open(target, '_blank');
        }
      },
      error: (jqXHR, exception) => {}
    });
  } else {
    $('.gated').removeClass('gated--hidden');
  }
});

if ($('[data-modal="waiting_approval_modal"]')) {
  $('[data-modal="waiting_approval_modal"]').trigger('modal:show');
}

// Gated Add To Card
$('form.cart.gated').on('submit', (event) => {
  event.preventDefault();
  $('.gated').removeClass('gated--hidden');
});

// handle quantity
$('.btn__qty').on('click', (event) => {
  event.preventDefault();
  const button = $(event.currentTarget);
  const update = $('[name="update_cart"]');
  const value = button.parent().find('.qty').val();

  button.parent().find('.qty').val(changeQty(button, value));

  // remove disabled attribute from button if it exists
  if (
    typeof update.attr('disabled') !== undefined &&
    update.attr('disabled') !== false
  ) {
    update.removeAttr('disabled');
  }
});

// quantity handler
function changeQty(type, value) {
  const btn = type;
  const oldValue = value;
  let newValue = parseFloat(oldValue);

  if (btn.data('qtyInput') == 'plus') {
    newValue += 1;
  } else if (btn.data('qtyInput') == 'minus') {
    // verify value is not below 1
    if (oldValue > 1) {
      newValue -= 1;
    } else {
      newValue = 1;
    }
  }

  value = newValue;

  return value;
}

function showRequiredFields(show) {
  const non_required_fields = [
    'address',
    'city',
    'state',
    'phone',
    'company',
    'country'
  ];
  non_required_fields.forEach((element) => {
    let non_required_input;

    if (element === 'state' || element === 'country') {
      non_required_input = $(`select[name="${element}"]`);

      if (show) {
        non_required_input.parent().parent().addClass('form__field--required');
      } else {
        non_required_input
          .parent()
          .parent()
          .removeClass('form__field--required');
      }
    } else {
      non_required_input = $(`input[name="${element}"]`);

      if (show) {
        non_required_input.parent().addClass('form__field--required');
      } else {
        non_required_input.parent().removeClass('form__field--required');
      }
    }
  });
}

// BG Image lazyload
const lazyObjectObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const lazyObject = entry.target;
        if (lazyObject.dataset.lazyBg) {
          const bgImgSrc = lazyObject.dataset.lazyBg;
          lazyObject.style.backgroundImage = 'url(' + bgImgSrc + ')';
          lazyObject.dataset.lazyBg = '';
          lazyObjectObserver.unobserve(lazyObject);
        }
      }
    });
  },
  {
    root: null, // 'null' = browser viewport
    rootMargin: '0px 0px 0px 0px',
    threshold: 0
  }
);

function createLazyObjects() {
  const lazyObjects = Array.from(document.querySelectorAll('[data-lazy-bg]'));
  lazyObjects.forEach((lazyObject) => lazyObjectObserver.observe(lazyObject));
}

document.addEventListener('DOMContentLoaded', createLazyObjects);
document.addEventListener('facetWPUpdated', createLazyObjects);
